// Wallet brand icons. Uses the official brand assets shipped in /public/wallets
// (downloaded from each wallet's official site/brand resources) and falls back
// to inline vector marks for wallets without a local asset.
const OFFICIAL_ASSETS = {
  phantom: "/wallets/phantom.png",
  metamask: "/wallets/metamask.svg",
  solflare: "/wallets/solflare.png",
  trust: "/wallets/trust.png",
};

export function walletAssetUrl(name) {
  const key = String(name || "").toLowerCase();
  for (const [brand, url] of Object.entries(OFFICIAL_ASSETS)) {
    if (key.includes(brand)) return url;
  }
  return null;
}

export function WalletIcon({ name, size = 20, className = "" }) {
  const key = String(name || "").toLowerCase();
  const dim = { width: size, height: size };
  const asset = walletAssetUrl(name);

  if (asset) {
    return (
      <img src={asset} alt={name || "wallet"} style={dim}
        className={`shrink-0 rounded-md object-contain ${className}`}
        data-testid={`wallet-icon-${key.split(/[^a-z0-9]/)[0] || "wallet"}`} />
    );
  }

  if (key.includes("coinbase")) {
    return (
      <svg {...dim} viewBox="0 0 40 40" className={`shrink-0 ${className}`} data-testid="wallet-icon-coinbase">
        <circle cx="20" cy="20" r="18" fill="#0052FF" />
        <path d="M20 9.5c-5.8 0-10.5 4.7-10.5 10.5S14.2 30.5 20 30.5 30.5 25.8 30.5 20 25.8 9.5 20 9.5zm0 13.2a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4z" fill="#fff" />
      </svg>
    );
  }

  if (key.includes("walletconnect")) {
    return (
      <svg {...dim} viewBox="0 0 40 40" className={`shrink-0 ${className}`} data-testid="wallet-icon-walletconnect">
        <rect width="40" height="40" rx="12" fill="#3B99FC" />
        <path d="M11.2 15.6c4.9-4.8 12.7-4.8 17.6 0l.6.6c.25.24.25.63 0 .87l-2 2c-.13.12-.33.12-.46 0l-.82-.8c-3.4-3.34-8.94-3.34-12.36 0l-.88.86c-.13.12-.33.12-.46 0l-2-2c-.25-.24-.25-.63 0-.87l.62-.66zm21.74 4.13 1.78 1.75c.25.24.25.63 0 .87l-8.03 7.87c-.25.25-.66.25-.91 0l-5.7-5.6a.22.22 0 0 0-.32 0l-5.7 5.6c-.25.25-.66.25-.91 0l-8.03-7.87a.62.62 0 0 1 0-.87l1.78-1.75c.25-.25.66-.25.91 0l5.7 5.59c.09.09.23.09.32 0l5.7-5.59c.25-.25.66-.25.91 0l5.7 5.59c.09.09.23.09.32 0l5.7-5.59c.25-.25.66-.25.91 0z" fill="#fff" />
      </svg>
    );
  }

  if (key.includes("rainbow")) {
    return (
      <svg {...dim} viewBox="0 0 40 40" className={`shrink-0 ${className}`} data-testid="wallet-icon-rainbow">
        <defs>
          <linearGradient id="rainbow-g" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0%" stopColor="#1B44E4" />
            <stop offset="45%" stopColor="#1849CA" />
            <stop offset="100%" stopColor="#FF5E90" />
          </linearGradient>
        </defs>
        <rect width="40" height="40" rx="12" fill="url(#rainbow-g)" />
        <path d="M11 28.6c0-9.7 7.9-17.6 17.6-17.6v5.2c-6.8 0-12.4 5.6-12.4 12.4z" fill="#fff" />
      </svg>
    );
  }

  // Generic fallback
  return (
    <svg {...dim} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
      className={`shrink-0 text-zinc-400 ${className}`}>
      <rect x="3" y="6" width="18" height="13" rx="2.5" />
      <path d="M16.5 12.5h.01" strokeLinecap="round" strokeWidth="2" />
    </svg>
  );
}
